import { createSlice } from '@reduxjs/toolkit';
const permission: any = {};
const role: any = {};
const rolePermissions: any = {};
const filters: any = {};

const rolesAndPermissionsReducer = createSlice({
	name: 'rolesAndPermissions',
	initialState: {
		isLoading: false,
		roles: [],
		role,
		permissions: [],
		permission,
		filters,
		rolePermissions,
	},
	reducers: {
		setRolesAndPermissionsIsLoading: (state) => {
			state.isLoading = true;
		},
		resetRolesAndPermissionsIsLoading: (state) => {
			state.isLoading = false;
		},
		setRoles: (state, action) => {
			state.roles = action.payload;
		},
		resetRoles: (state) => {
			state.roles = [];
		},
		setRole: (state, action) => {
			state.role = action.payload;
		},
		resetRole: (state) => {
			state.role = {};
		},
		setPermissions: (state, action) => {
			state.permissions = action.payload;
		},
		resetPermissions: (state) => {
			state.permissions = [];
		},
		setRolePermissions: (state, action) => {
			state.rolePermissions = action.payload;
		},
		resetRolePermissions: (state) => {
			state.rolePermissions = {};
		},
		setPermission: (state, action) => {
			state.permission = action.payload;
		},
		resetPermission: (state) => {
			state.permission = {};
		},
	},
});
export const {
	setRolesAndPermissionsIsLoading,
	resetRolesAndPermissionsIsLoading,
	setPermissions,
	resetPermissions,
	setPermission,
	setRolePermissions,
	resetRolePermissions,
	resetPermission,
	setRoles,
	resetRoles,
	setRole,
	resetRole,
} = rolesAndPermissionsReducer.actions;
export default rolesAndPermissionsReducer.reducer;
